import { createSlice } from '@reduxjs/toolkit';

const FJGoogleDriveModalSlice = createSlice({
    name: 'FJGoogleDriveModal',
    initialState: {
        isShow: false,
    },
    reducers: {
        setIsShow(state, action) {
            state.isShow = action.payload;
        },
    }
})

export default FJGoogleDriveModalSlice